import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { connect } from 'react-redux';
import { branch, compose, lifecycle, renderComponent, renderNothing, withProps } from 'recompose';
import { Table } from 'react-bootstrap';
import _ from 'lodash';


import UnreviewReasonPopover from '../../../components/UnreviewReasonPopover';
import jobInvoiceInbox from '../graphql/jobInvoiceInbox';
import { selectJobId, setSorted } from '../actions';
import { querySelector } from '../../../utils';
import { handleRowColor } from '../utils';
import { getSorted } from '../selectors';

import '../styles.css';

const propTypes = exact({
  jobs: PropTypes.arrayOf(PropTypes.object).isRequired,
  selectedJobId: PropTypes.number.isRequired,
  selectJobIdAction: PropTypes.func.isRequired,

  setSortedAction: PropTypes.func.isRequired,
  sorted: PropTypes.object.isRequired,
});


const JobInvoiceInbox = (props) => {
  const { selectedJobId, selectJobIdAction, jobs } = props;

  const renderJobRow = (job) => {
    const {
      id,
      approvedAt,
      jobNumber,
      hasUnreviewReasons,
      jobUnreviewReasons,
      invoiceState,
      accountingState,
      leaseName,
      mostRecentTicketDate,
    } = job;

    const listDate = `${approvedAt.month}/${approvedAt.day}`;
    const isActive = id === selectedJobId;
    const handleClick = () => { selectJobIdAction(id); };
    const departments = querySelector(job, 'departments.edges[*].node.name', []);
    const invoicableStateColor = handleRowColor(invoiceState, isActive, accountingState);

    return (
      <tr
        style={{ backgroundColor: invoicableStateColor }}
        key={id}
        onClick={handleClick}
      >
        <td>{listDate}</td>
        <td>{mostRecentTicketDate}</td>
        <td>{jobNumber}</td>
        <td>{leaseName}</td>
        <td>{departments.join(', ')}</td>
        <td>
          {hasUnreviewReasons && <UnreviewReasonPopover unreviewReasons={jobUnreviewReasons} />}
        </td>
      </tr>
    );
  };

  const sortingMethod = (paramColumnName) => {
    const { setSortedAction, sorted: { columnName, order } } = props;

    let newOrder = 'asc';
    if (paramColumnName === columnName) {
      if (order === 'asc') {
        newOrder = 'desc';
      }
    }

    setSortedAction({ columnName: paramColumnName, order: newOrder });
  };

  /* NOTE: there's no sticky header for react-bootstrap table, so using class
   sortable-header to give the illusion of it being. */
  return (
    <div style={{ maxHeight: '64vh', overflowY: 'auto', overflowX: 'hidden' }}>
      <Table>
        <thead>
          <tr>
            <th className="header pointer" onClick={() => { sortingMethod('approvedDate'); }}>Approve Date</th>
            <th className="header pointer" onClick={() => { sortingMethod('mostRecentTicketDate'); }}>Recent Ticket Date</th>
            <th className="header pointer" onClick={() => { sortingMethod('jobNumber'); }}>Job</th>
            <th className="header pointer" onClick={() => { sortingMethod('leaseName'); }}>Lease</th>
            <th className="header pointer" onClick={() => { sortingMethod('allDepartments'); }}>Depts</th>
            <th className="header" />
          </tr>
        </thead>
        <tbody>
          {jobs.map(renderJobRow, this)}
        </tbody>
      </Table>
    </div>
  );
};


JobInvoiceInbox.propTypes = propTypes;


const mapStateToProps = (state) => {
  return {
    sorted: getSorted(state),
    selectedJobId: state.ticketInvoicing.jobId,
  };
};


const mapDispatchToProps = {
  selectJobIdAction: selectJobId,
  setSortedAction: setSorted,
};


const withRedux = connect(mapStateToProps, mapDispatchToProps);


const withHide = branch(
  (props) => { return props.selectedJobId === null; },
  renderNothing,
);


/*
* NOTE: This empty component depends on its parent being a panel.
* I'm not how to handle these HTML "dependencies" this at the moment.
*/
const withNoJobs = branch(
  (props) => {
    return props.jobs.length === 0;
  },
  renderComponent((props) => {
    return (
      <div className="panel-body" style={{ textAlign: 'center' }}>
        <h4>Empty</h4>
        <p className="text-muted">No Jobs are available for invoicing</p>
      </div>
    );
  }),
);

const withJobSorting = withProps((props) => {
  /* NOTE: taking in jobs from graphql and return sorted jobs
  * as the variable jobs */
  const { jobs: unsortedJobs, sorted } = props;

  const jobs = _.orderBy(unsortedJobs, (job) => {
    return job[sorted.columnName];
  }, [sorted.order]);

  return { jobs };
});


const withSelectFirstJob = lifecycle({
  componentWillMount() {
    const { jobs, selectJobIdAction } = this.props;
    if (jobs.length > 0) {
      selectJobIdAction(jobs[0].id);
    }
  },
});


const enhance = compose(
  jobInvoiceInbox,
  withRedux,
  withJobSorting,
  withNoJobs,
  withSelectFirstJob,
  withHide,
);


export default enhance(JobInvoiceInbox);
